import * as React from "react";
import { Button } from "carbon-components-react";
import { DocumentImport20 } from "@carbon/icons-react";

import { WS_NAME } from "./wsDefs";

const styles = require("./styles.module.scss");

interface IImportDataProps {
  onClick: Function;
  wsName: string;
}

// TODO: jjw: restructure wsDefs.ts to also own this ws-centric display info

const customInfo = {
  [WS_NAME.SELLER_CREDITS]: {
    buttonText: "Import fields from PC",
    confText:
      "Import fields? This will pull in the current purchase price and " +
      "credit amount/percentage, then re-calculate the final amount as needed.",
  },
};

const ImportData: React.SFC<IImportDataProps> = ({ onClick, wsName }) => {
  const shouldRender =
    [
      WS_NAME.ESCROWS,
      WS_NAME.PREPAIDS,
      WS_NAME.SELLER_CREDITS,
      WS_NAME.UNDERWRITING_SUMMARY,
      WS_NAME.RESERVES,
    ].indexOf(wsName) >= 0;

  const onClickConfirm = () => {
    const confText = customInfo[wsName] && customInfo[wsName].confText;

    if (confText && confirm(confText)) {
      onClick();
    } else if (!confText) {
      onClick();
    }
  };

  let buttonText;
  if (customInfo[wsName] && customInfo[wsName].buttonText) {
    buttonText = customInfo[wsName].buttonText;
  } else {
    buttonText = "Import data from documents/defaults";
  }

  return (
    shouldRender && (
      <Button
        kind="tertiary"
        className={styles.import}
        onClick={onClickConfirm}
        renderIcon={DocumentImport20}
      >
        {buttonText}
      </Button>
    )
  );
};

export default ImportData;
